<mat-form-field>
    <mat-label>Vælg installation fra huskeliste</mat-label>

    <mat-select [formControl]="control">
        @for (option of options$ | async; track option) {
            <mat-option [value]="option.key"> {{ option.value }}</mat-option>
        }
    </mat-select>
</mat-form-field>
